import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import classnames from 'classnames';
import { formatSurveyRoute } from '../../../../../Survey/routes';
import {
  fetchSurveyResponses,
  getSurveyResponses,
} from '../../../../../Survey/surveySlice';
import EnableForProjectState from '../../../../security/EnableForProjectState';
import WelcomeBox from '../WelcomeBox';
import useUserReadability from '../../../../../common/hooks/useUserReadability.ts';

const WelcomeBoxBeginQuestionnaire = () => {
  const { projectId } = useParams();
  const dispatch = useDispatch();
  const isUserReadonly = useUserReadability(projectId);

  const surveyResponses = useSelector(getSurveyResponses);

  useEffect(() => {
    if (!surveyResponses) {
      dispatch(fetchSurveyResponses(projectId));
    }
  }, [dispatch, projectId, surveyResponses]);

  const hasStartedSurvey = surveyResponses && !!surveyResponses.answers.length;

  if (isUserReadonly) {
    return null;
  }

  return (
    surveyResponses && (
      <EnableForProjectState projectId={projectId}>
        {({ isProjectDisabled }) => (
          <WelcomeBox
            isDisabled={isProjectDisabled}
            isReturnUser={hasStartedSurvey}
          >
            <p>
              {hasStartedSurvey
                ? 'Continue where you left off '
                : 'Start your project '}
              by completing the Diagnostic Questionnaire.
            </p>
            <Link
              to={!isProjectDisabled && formatSurveyRoute(projectId)}
              className={classnames('link-button', {
                'grey-button': isProjectDisabled,
                'green-text white-button': !isProjectDisabled,
              })}
              aria-label="Questionnaire"
              disabled
            >
              {hasStartedSurvey
                ? 'Continue Questionnaire'
                : 'Start Questionnaire'}
            </Link>
          </WelcomeBox>
        )}
      </EnableForProjectState>
    )
  );
};

export default WelcomeBoxBeginQuestionnaire;
